program IconViewer;

uses
  Vcl.Forms,
  WEBLib.Forms,

  uMain in 'uMain.pas'{*.html};

{$R *.res}

begin
//alog.Init('dell.am1.com','test');
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm3, Form3);
  Application.Run;
end.
